export default {
  COLOR_PALETTE_VARIABLE: 'colorPalette',
  FONTS_VARIABLE: 'fonts',
  BUTTON_PRESET_VARIABLE: 'buttonPreset',
  EFFECTS_VARIABLE: 'effects',
  GLOBAL_STYLES_VARIABLE: 'globalStyles',
  FONTS_DATA_ATTRIBUTE: 'data-current-fonts',
  PARENT_FONTS_DATA_ATTRIBUTE: 'data-parent-fonts',
  FALLBACK_FONT_PAIR_ID: 'noto-sans_noto-sans',
  COLOR_PALETTE_DATA_ATTRIBUTE: 'data-color-palette',
  WEBSITE_ANIMATION_DATA_ATTRIBUTE: 'data-website-animation',
  BUTTON_PRESET_DATA_ATTRIBUTE: 'data-current-button-preset',
  INIT_WEBSITE_ANIMATION_DATA_ATTRIBUTE: 'data-init-website-animation',
  MAX_COLOR_TEXT_OPTIONS: 3,
  MAX_CUSTOM_COLORS_AMOUNT: 50,
  MAX_CUSTOM_GRADIENTS_AMOUNT: 50,
  CUSTOM_COLOR_SCHEME_PREFIX: 'ws-custom-',
};
